import { Page } from "components/page/page.component"
import { View } from "components/view/view.component"
import style from './alerts.style.module.css'
import { Filters } from "components/filters/filters.component"
import { getMonthsBefore } from "utils/date.util"
import { FilterType } from "model/filter.model"
import { Table, TableBody, TableCell, TableRow  } from 'components/table/table.component'
import { Text } from "components/text/text.component"
import { useGetAlertsApi } from "api/alert.api"
import { useEffect, useState } from "react"
import { Skeleton } from "components/skeleton"

type AlertsPageProps = {
    companyId: string
}

export function AlertsPage({companyId}: AlertsPageProps) {

    const [filter, setFilter] = useState<FilterType>()
    const{loading, get: getAlerts, data: alerts} = useGetAlertsApi()

    useEffect(()=>{
        listAlerts()
    // eslint-disable-next-line
    }, [filter])

    function listAlerts(){
        const _filter = {
            companies: [companyId],
            buildings: filter?.buildings?.map(_ => _.id),
            indicators: filter?.indicators?.map(_ => _.id),
            startDate: filter?.startDate,
            endDate: filter?.endDate
        }
        getAlerts(_filter)
    }

    function handleOnFilterChange(filter: FilterType){
        setFilter(filter)
    }

    return <Page className={style.Page} title="Alertas" header menu >
        <View className={style.Content}>
            <Filters 
                companyId={companyId} 
                showBuildings 
                showBuildingGroups 
                showStartDate
                initialStartDate={getMonthsBefore(new Date(), 4)}
                initialEndDate={getMonthsBefore(new Date(), 2)}
                showEndDate 
                showIndicators
                indicatorsFor='alert' 
                onChange={handleOnFilterChange}
                canExpand
                expanded={false}
            />
            {
            loading ?
            <Skeleton className={style.Skeleton} />
            :
            <View className={style.TableContainer}>
                {/* <Text type='h4'>Alertas</Text> */}
                <Table>
                    { !alerts || alerts.length <= 0 ?
                    <TableBody>
                        <TableRow>
                            <TableCell>
                                <Text type='h4'>Você não tem nenhum alerta.</Text>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                    :
                    <TableBody>
                        {alerts.map(alert => <TableRow>
                            <TableCell>
                                <Text type='h4' style={{color:'var(--red-primary-color)'}}>{alert.message}</Text>
                            </TableCell>
                        </TableRow>)}
                    </TableBody>
                    }
                </Table>    
            </View>
            }
        </View>
    </Page>
}